import React from "react";
import { IonContent, IonPage } from "@ionic/react";

import HeaderMenu from "../components/HeaderMenu";

const ClinicalInformation: React.FC = () => {
  return (
    <IonPage>
      <HeaderMenu title="Clinical Information" />
      <IonContent class="ion-padding">
        <h1>ClinicalInformation page</h1>
      </IonContent>
    </IonPage>
  );
};

export default ClinicalInformation;
